// extracted by mini-css-extract-plugin
var _1 = "ImportFileModal-module__footer--uo6C0";
export { _1 as "footer" }
